import React, { useState } from "react";
import { IoCopyOutline } from "react-icons/io5";
import { notification, Flex, Spin } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { FRONT_BASE_URL } from "../../config/constants";
import { sentInvitationEmail } from "../../controllers/investor/accounts";
const InvitePopup = ({ showInvite = false, toggleShowInvite }) => {
  const [recipientEmail, setRecipientEmail] = useState("");
  const USERDATA = JSON.parse(sessionStorage.getItem("USER-INFO"));
  const [isLoading, setIsLoading] = useState(false);
  const handleSendInvitation = async () => {
    try {
      setIsLoading(true);
      const multiEmailRegex = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s*,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;
      if (!multiEmailRegex.test(recipientEmail)) {
        notification.open({
          message: "Oops!",
          description: `Enter valid email.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      }
      if (recipientEmail && recipientEmail.trim() !== "") {
        const option = {
          // firmname: USERDATA?.firm?.investor_firm_name,
          firmname: `${USERDATA?.investor_first_name || ''}${
                        USERDATA?.investor_last_name
                          ? ` ${USERDATA.investor_last_name}`
                          : ''
                      } from ${USERDATA?.firm?.investor_firm_name || ''}`,
          invitelink: `${FRONT_BASE_URL}/invitation`,
          inviteemail: recipientEmail,
        };
        const res = await sentInvitationEmail(option);
        if (res?.status === true) {
          notification.open({
            message: "Success",
            description: `Invitation sent successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message || "Failed to send invitation."}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 3,
          });
        }
        toggleShowInvite();
        setRecipientEmail("");
      }else{
        notification.open({
          message: "Oops!",
          description: `Recipient emails is required.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleCopyInvitation = async () => {
    try {
      navigator.clipboard.writeText(
        `${FRONT_BASE_URL}/invitation`
      );
      notification.open({
        message: "Success",
        description: `Invitation link copied to clipboard.`,
        placement: "topRight",
        icon: <CheckCircleOutlined style={{ color: "green" }} />,
        duration: 2,
      });
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Failed to copy invitation link to clipboard.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  const handleEmailChange = async (e) => {
    try {
      const { value } = e.target;
      setRecipientEmail(value.trim());
    } catch (error) {}
  };

  return (
    <div
      className="modal fade show"
      style={{
        display: `${showInvite ? "block" : "none"}`,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-body text-center pt-2 pb-4 login_popup_modal">
            <h5 className="mb-4  scan_the_qr_code"> Invite Members </h5>
            <div className="row">
              <div className="col-md-12 mb-12">
                <h6 className="mb-3">Recipient Email(s)</h6>
                <input
                  type="text"
                  name="recipientEmail"
                  id="recipientEmail"
                  value={recipientEmail}
                  onChange={handleEmailChange}
                  placeholder="abc@chirate.com, zyx@chirate.com,...,.."
                  className="form-control all_input"
                />
                <small className="mt-4">
                  (Hint: Separate multiple emails with commas)
                </small>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="profile_submit_btn mt-4 mx-2">
                <button type="button" onClick={handleCopyInvitation}>
                  Copy <IoCopyOutline />{" "}
                </button>
              </div>
              <div className="profile_submit_btn mt-4">
                <button type="button" disabled={isLoading} onClick={handleSendInvitation}>
                  {isLoading?`Sending`:`Send Invitation`}
                </button>
              </div>
            </div>

            {/* <hr/>
            <div className="row mt-0">
            <NavLink to='https://wa.me/?text=Hi!%20You%20are%20invited%20to%20join%20Chiratae%20Spotlight.%20Click%20here:%20https://example.com/join' target='__blank' className={`whatsApp_Invitation`} > <IoLogoWhatsapp/></NavLink>
            </div> */}
          </div>
          <div className="position-absolute user_login_top_right_cross_btn">
            <button className="top-0 end-0 m-3" onClick={toggleShowInvite}>
              {" "}
              x{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InvitePopup;
